module.exports = __webpack_public_path__ + "media/images/flags/64/Equatorial-Guinea-1cf870a6c4d583eb0e83e010ddc6caae.png";